import { apiClientWithRefreshToken } from "@/api/apiClient";
import { FreelancerPayslipFormSchema } from "@/v2/schema/payslip";
import { Payslip } from "@/v2/types";

export default async function UpdateFreelancerPayslip({
  id,
  data,
}: {
  id: string;
  data: FreelancerPayslipFormSchema;
}): Promise<Payslip> {
  const res = await apiClientWithRefreshToken({
    url: `/payslips/${id}`,
    method: "PUT",
    data: data,
  });

  return res.data;
}
